import React, { useState, useEffect } from 'react';

const MapRowColumn = ({
  questionNumber = "1",
  rows = [],
  columns = [],
  correctAnswer = [],
  onCalculateScore,
  image
}) => {
  const [selectedCells, setSelectedCells] = useState({});
  const [answers, setAnswers] = useState([]);

  const handleRadioChange = (rowIndex, colIndex) => {
    setSelectedCells(prevSelectedCells => ({
      ...prevSelectedCells,
      [rowIndex]: colIndex
    }));
  };

  useEffect(() => {
    const allRowsSelected = rows.length === Object.keys(selectedCells).length;
    if (allRowsSelected) {
      const selectedAnswers = Object.values(selectedCells);
      setAnswers(selectedAnswers);
      const indexToLetter = (index) => String.fromCharCode(65 + index); // 65 is the char code for 'A'
      const translatedAnswers = selectedAnswers.map(indexToLetter);
      onCalculateScore(4, questionNumber, translatedAnswers, correctAnswer);
    }
  }, [selectedCells, rows.length]);

  return (
    <div className="w-full p-2 bg-white font-inter flex">
      {/* Image */}
      <div className="mr-4">
        <img src={image} alt="Description" className="w-100 h-100 object-cover" />
      </div>
      {/* Grid Container */}
      <div className="bg-white p-3 w-[313px]">
        {/* Column Headers */}
        <div className="grid" style={{ gridTemplateColumns: `100px repeat(${columns.length}, 1fr)` }}>
          <div className="border border-gray-300"></div>
          {columns.map((col, index) => (
            <div key={index} className="border border-gray-300 text-center text-sm p-1">
              {col}
            </div>
          ))}
        </div>
        {/* Options Rows */}
        {rows.map((option, rowIndex) => (
          <div key={rowIndex} className="grid border-b border-gray-300" style={{ gridTemplateColumns: `100px repeat(${columns.length}, 1fr)` }}>
            <div className="border border-gray-300 text-sm p-1 text-left">
              {option}
            </div>
            {columns.map((_, colIndex) => (
              <div
                key={colIndex}
                className={`border border-gray-300 flex items-center justify-center ${selectedCells[rowIndex] === colIndex ? 'bg-blue-200' : ''}`}
              >
                <input
                  type="radio"
                  name={`row-${rowIndex}`}
                  className="cursor-pointer w-4 h-4 rounded-full border border-gray-300 checked:bg-blue-500 checked:border-blue-500"
                  onChange={() => handleRadioChange(rowIndex, colIndex)}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MapRowColumn;